module.exports = __webpack_public_path__ + "static/img/kf.1f49f4fa.png";